import OfferModalSidebar from '../OfferModalSidebar/offer-modal-sidebar';

export default OfferModalSidebar;